import type { LucideProps } from 'lucide-react'

export const Coins = (props: LucideProps) => {
	return (
		<svg
			width="22"
			height="21"
			viewBox="0 0 22 21"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Coins</title>
			<path
				d="M19 11.5V14.5C19 15.8 15.866 17.5 12 17.5C8.134 17.5 5 15.8 5 14.5V12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.29395 12.2591C6.15895 13.4071 8.83395 14.4841 11.9999 14.4841C15.8659 14.4841 18.9999 12.8781 18.9999 11.4981C18.9999 10.7231 18.0129 9.87408 16.4639 9.27808"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 6.5V9.5C16 10.8 12.866 12.5 9 12.5C5.134 12.5 2 10.8 2 9.5V6.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 9.484C12.866 9.484 16 7.878 16 6.498C16 5.118 12.866 3.5 9 3.5C5.134 3.5 2 5.117 2 6.498C2 7.878 5.134 9.484 9 9.484Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
